<div style="width:1000px">
    <p-tabView>
        <p-tabPanel header="Drafts">
            <!-- Keep header template to line up Drafts tab with other tabs  -->
            <ng-template pTemplate="header">
                <span class="tab-header"> 
                    <span class="badge-placeholder"></span> 
                    Drafts
                    <span class="badge-placeholder"></span> 
                </span>
            </ng-template>
            <p-overlayPanel #draftEditor appendTo="body" #emailEditor styleClass="overflow-y-scroll" (onHide)="editorClosed()">
                <app-email-composer *ngIf="selectedDraft" [emailHandler]="emailHandler" [draftEmail]="selectedDraft" (sendEmail)="draftEditor.hide(); sendDraft($event)" (cancelEmail)="draftEditor.hide(); editorClosed();" (draftSaved)="draftEditor.hide(); editorClosed();"></app-email-composer>
            </p-overlayPanel>
            <p-panel header="Encounter" [toggleable]="true">
                <p-table [value]="encounterDraftEmailItems || []" [paginator]="true" sortMode="single" [rows]="5">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Last Saved Date</th>
                            <th>Recipient</th>
                            <th>Subject</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-email>
                        <tr> 
                            <ng-container *ngIf="email.getDraftEmail() as draft">
                                <td>
                                    {{draft.dateLastSaved | date: 'short'}}
                                </td>
                                <td>
                                    <p-tag *ngFor="let r of draft.recipients" icon="pi pi-user" [rounded]="true" [value]="r"/>
                                </td>
                                <td>
                                    {{draft.subject}}
                                </td>
                                <td>
                                    <p-button [text]="true" label="GoTo" icon="pi pi-external-link" (click)="goToRelatedEncounter(email)"></p-button> 
                                </td>`
                                <td>
                                    <p-button icon="pi pi-pencil" label="Edit" [text]="true"  (onClick)="openEditor(email, $event);"></p-button>
                                    
                                </td>
                                <td>
                                    <p-button label="Delete" severity="danger" (onClick)="deleteButtonPressed($event, draft.id, draft.draftType);" ></p-button>    
                                </td>
                            </ng-container>
                        </tr>
                    </ng-template>
                </p-table>
            </p-panel>
            <p-panel header="Referral" [toggleable]="true">
                <p-table [value]="referralDraftEmailItems" [paginator]="true" sortMode="single" [rows]="5">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Last Saved Date</th>
                            <th>Recipient</th>
                            <th>Subject</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-email>
                        <tr>
                            <ng-container *ngIf="email.getDraftEmail() as draft">
                                <td>
                                    {{draft.dateLastSaved | date: 'short'}}
                                </td>
                                <td>
                                    <p-tag *ngFor="let r of draft.recipients" icon="pi pi-user" [rounded]="true" [value]="r"/>
                                </td>
                                <td>
                                    {{draft.subject}}
                                </td>
                                <td>
                                    <p-button [text]="true" label="GoTo" icon="pi pi-external-link" (click)="goToRelatedEncounter(email)"></p-button> 
                                </td>
                                <td>
                                    <p-button icon="pi pi-pencil" label="Edit" [text]="true"  (onClick)="openEditor(email, $event);"></p-button>
                                    
                                </td>
                                <td>
                                    <p-button label="Delete" severity="danger" (onClick)="deleteButtonPressed($event, draft.id, draft.draftType);" ></p-button>    
                                </td>
                            </ng-container>
                        </tr>
                    </ng-template>
                </p-table>
            </p-panel>
        </p-tabPanel>
        <p-tabPanel>
            <ng-template pTemplate="header">
                <span class="tab-header">
                    Received
                    <p-badge  
                        *ngIf="(sortedEmails.length || 0) + (sortedUnreadEmails.length || 0) > 0"
                        [value]="(sortedEmails.length || 0) + (sortedUnreadEmails.length || 0)"
                        severity="info"
                        styleClass="ml-2 new-badge">
                    </p-badge>
                </span>
            </ng-template>
            <p-panel [toggleable]="true">
                <ng-template pTemplate="header">
                    <span class="p-panel-title">
                        Non-categorized
                        <p-badge  
                            *ngIf="(sortedEmails.length || 0) > 0"
                            [value]="(sortedEmails.length || 0)"
                            severity="info"
                            styleClass="ml-2 new-badge">
                        </p-badge>
                    </span>
                </ng-template> 
                <p-table [value]="sortedEmails" [paginator]="sortedEmails.length > 5" sortMode="single" [rows]="5" sortField="dateReceived" [sortOrder]="-1">
                    <ng-template pTemplate="header">
                        <tr>
                            <th></th>
                            <th pSortableColumn="dateReceived">Received Date <p-sortIcon field="dateReceived" /></th>
                            <th>Recipient</th>
                            <th>Subject</th>
                            <th>
                                <p-button label="Assign" (onClick)="assignEncounterButtonPressed($event)" [disabled]="!allowAssignment()"></p-button>
                                <p-dropdown [options]="(encounters$ | async) || []" [(ngModel)]="encounter" optionLabel=id filter="true"></p-dropdown>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-email>
                        <tr>
                            <td>
                                <p-checkbox [inputId]="email.id" [value]="email" [(ngModel)]="selectedEmails"/>
                            </td>
                            <td>
                                {{email.dateReceived | date: 'short'}}
                            </td>
                            <td>
                                <p-tag icon="pi pi-user" [rounded]="true" [value]="email.from"/>
                            </td>
                            <td>
                                {{email.subject}}
                            </td>
                            <td>
                                <p-button icon="pi pi-eye" label="View" [text]="true"  (onClick)="viewEmail.toggle($event)"></p-button>
                                <p-overlayPanel appendTo="body" #viewEmail [style]="{width: '30vw', height:'30vh'}" styleClass="overflow-y-scroll">
                                    <div [innerHtml]="email.body"></div>
                                </p-overlayPanel>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-panel>
            <p-panel [toggleable]="true">
                <ng-template pTemplate="header">
                    <span class="p-panel-title">
                        Unread
                        <p-badge  
                            *ngIf="(sortedUnreadEmails.length || 0) > 0"
                            [value]="(sortedUnreadEmails.length || 0)"
                            severity="info"
                            styleClass="ml-2 new-badge">
                        </p-badge>
                    </span>
                </ng-template> 
                <p-table [value]="sortedUnreadEmails" [paginator]="sortedUnreadEmails.length > 5" sortMode="single" [rows]="5" sortField="dateReceived" [sortOrder]="-1">
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="dateReceived">Received Date <p-sortIcon field="dateReceived" /></th>
                            <th>Recipient</th>
                            <th>Subject</th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-email>
                        <tr [ngClass]="{'strikethrough-row': email.read}">
                            <td>
                                    {{email.dateReceived | date: 'short'}}
                                </td>
                                <td>
                                    <p-tag icon="pi pi-user" [rounded]="true" [value]="email.from"/>
                                </td>
                                <td>
                                    {{email.subject}}
                                </td>
                                <td>
                                    <p-button icon="pi pi-eye" label="View" [text]="true"  (onClick)="viewEmail.toggle($event); "></p-button>
                                    <p-overlayPanel appendTo="body" #viewEmail [style]="{width: '30vw', height:'30vh'}" styleClass="overflow-y-scroll" (onHide)="emailViewed($event, email.id, email.read);">
                                        <div [innerHtml]="email.body"></div>
                                    </p-overlayPanel>
                                </td>
                            </tr>
                    </ng-template>
                </p-table>
            </p-panel>
        </p-tabPanel>
    </p-tabView>
</div>
